import React from 'react';
import { matchPath } from "react-router-dom";
import { Layout } from './components/layouts';
import { PlainLayout } from "./components/layouts/PlainLayout";
import { LoginPage } from "./pages/LoginPage";
import { PasswordResetMailSendPage } from "./pages/PasswordResetMailSendPage";
import { PasswordResetEditPage } from "./pages/PasswordResetEditPage";
// ToDo: 完全に不要になったら消す
// import { CustomerConfirmPage } from "./pages/CustomerConfirmPage";
import { TaskBoardLayout } from './components/layouts/TaskBoardLayout';
import { TaskListPage } from './pages/TaskListPage';
import { RoomAttachFilePage } from './pages/RoomAttachFilePage';
import { RoomMemberPage } from './pages/RoomMemberPage';
import { AdminDefaultLayout } from './components/layouts/admin/AdminDefaultLayout';
import { MenuMaterialListPage } from './pages/admin/MenuMaterialListPage';
import { MenuMaterialCreatePage } from './pages/admin/MenuMaterialCreatePage';
import { MenuMaterialEditPage } from './pages/admin/MenuMaterialEditPage';
import { LabelSetListPage } from './pages/admin/LabelSetListPage';
import { LabelSetCreatePage } from './pages/admin/LabelSetCreatePage';
import { LabelSetEditPage } from './pages/admin/LabelSetEditPage';
import { MenuSetListPage } from './pages/admin/MenuSetListPage';
import { MenuSetCreatePage } from './pages/admin/MenuSetCreatePage';
import { MenuSetEditPage } from './pages/admin/MenuSetEditPage';
import { RoomListPage } from './pages/admin/RoomListPage';
import { RoomCreatePage } from './pages/admin/RoomCreatePage';
import { RoomEditPage } from './pages/admin/RoomEditPage';
import { RoomMemberEditPage } from './pages/admin/RoomMemberEditPage';
import { RoomSelectPage } from './pages/RoomSelectPage';
import { DefaultLayout } from "./components/layouts/DefaultLayout";
import { ForbiddenPage } from "./pages/errors/ForbiddenPage";
import { InternalServerErrorPage } from "./pages/errors/InternalServerErrorPage";
import { NotFoundPage } from "./pages/errors/NotFoundPage";
import { CustomerListPage } from './pages/admin/CustomerListPage';
import { SalesmanListPage } from './pages/admin/SalesmanListPage';
import { AdminListPage } from './pages/admin/AdminListPage';

/**
 * ルート定義
 */
export type RouteOptions = {
  path: string;
  layout: Layout;
  component: React.FC;
  needAuth: boolean;
};

// prettier-ignore
export const routes = {
  // 認証不要 ----------------------
  login: { path: '/login', component: LoginPage, layout: DefaultLayout, needAuth: false } as RouteOptions,
  passwordResetMailSend: { path: '/password/reset/mail', component: PasswordResetMailSendPage, layout: DefaultLayout, needAuth: false } as RouteOptions,
  passwordResetEdit: { path: '/password/reset/edit', component: PasswordResetEditPage, layout: DefaultLayout, needAuth: false } as RouteOptions,
  // ToDo: 完全に不要になったら消す
  // customerConfirm: { path: '/account/customer/confirm', component: CustomerConfirmPage, layout: DefaultLayout, needAuth: false } as RouteOptions,

  // エラー
  forbiddenError: { path: '/errors/403', component: ForbiddenPage, layout: DefaultLayout, needAuth: false } as RouteOptions,
  notFoundError: { path: '/errors/404', component: NotFoundPage, layout: DefaultLayout, needAuth: false } as RouteOptions,
  internalServerError: { path: '/errors/500', component: InternalServerErrorPage, layout: DefaultLayout, needAuth: false } as RouteOptions,

  // 認証要   ----------------------
  // 顧客ユーザー用画面
  roomSelect: { path: '/roomselect', component: RoomSelectPage, layout: PlainLayout, needAuth: true } as RouteOptions,
  taskList: { path: '/tasklist/:roomId', component: TaskListPage, layout: TaskBoardLayout, needAuth: true } as RouteOptions,
  roomAttachFile: { path: '/roomattachfile/:roomId', component: RoomAttachFilePage, layout: TaskBoardLayout, needAuth: true } as RouteOptions,
  roomMember: { path: '/roommember/:roomId', component: RoomMemberPage, layout: TaskBoardLayout, needAuth: true } as RouteOptions,

  // 営業ユーザー用画面
  menuMaterialList: { path: '/admin/material', component: MenuMaterialListPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  menuMaterialCreate: { path: '/admin/material/create', component: MenuMaterialCreatePage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  menuMaterialEdit: { path: '/admin/material/:id', component: MenuMaterialEditPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  labelSetList: { path: '/admin/labelset', component: LabelSetListPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  labelSetCreate: { path: '/admin/labelset/create', component: LabelSetCreatePage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  labelSetEdit: { path: '/admin/labelset/:id', component: LabelSetEditPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  menuSetList: { path: '/admin/menuset', component: MenuSetListPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  menuSetCreate: { path: '/admin/menuset/create', component: MenuSetCreatePage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  menuSetEdit: { path: '/admin/menuset/:id', component: MenuSetEditPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  roomList: { path: '/admin/room', component: RoomListPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  roomCreate: { path: '/admin/room/create', component: RoomCreatePage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  roomEdit: { path: '/admin/room/:id', component: RoomEditPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  roomMemberEdit: { path: '/admin/roommember/:id', component: RoomMemberEditPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  customerList: { path: '/admin/customer', component: CustomerListPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  salesmanList: { path: '/admin/salesman', component: SalesmanListPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
  adminList: { path: '/admin/admin', component: AdminListPage, layout: AdminDefaultLayout, needAuth: true } as RouteOptions,
};

export const route = (name: RouteName, urlParams: any = undefined): string => {
  let { path } = routes[name];

  if (urlParams) {
    Object.keys(urlParams)
      .forEach((key) => {
        path = path.replace(`:${key}`, urlParams[key]);
      });
  }

  return path;
};
export type RouteName = keyof typeof routes;
export const isNeedAuthRoute = (path: string): boolean => {
  const routeName = Object.keys(routes).find((key) => {
    return matchPath(
      path,
      {
        path: routes[key as RouteName].path,
        exact: true,
        strict: true,
      }
    ) !== null;
  });

  if (routeName === undefined) {
    return false;
  }

  return routes[routeName as RouteName].needAuth;
}

export const matchRoute = (path: string, name: RouteName): boolean => {
  const match = matchPath(
    path,
    {
      path: routes[name].path,
      exact: true,
      strict: true,
    }
  );
  return match !== null;
}
